import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalDownloadComponent } from './modal-download.component';

@NgModule({
  imports: [IonicModule, CommonModule],
  declarations: [ModalDownloadComponent],
  exports: [ModalDownloadComponent],
})
export class ModalDownloadModule {}
